import { onResetSearchFilter } from './search';
import { resetOtherFilter } from './otherFilter';

export function resetFiltres() {
  onResetSearchFilter();
  resetOtherFilter();
}
